<script lang="ts">
    import {
        VpCloseIcon,
        VpRefreshIcon,
        VpReturnIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import VerticalFiltersContent from '$saga/views/Search/components/verticalFilters/VerticalFiltersContent.svelte';
    import {
        filteredToursCount,
        filtersContext,
    } from '$saga/views/Search/store';
    import { handleResetSecondaryValues } from '$saga/views/Search/utils';

    export let title, close, resetView, closeDrawer, handleSelectedFilter;
</script>

<section class="flex h-full flex-col overflow-hidden">
    <!--HEADER -->
    <div
        class="sticky top-0 mx-l flex min-h-[65px] items-center justify-between border-b border-solid border-border-quiet bg-white px-l py-m desktop:px-3xl"
    >
        <h2 class="font-semibold" {...$title} use:title>
            {trans('search.filter.sidebar.title')}
        </h2>
        <button
            {...$close}
            use:close
            aria-label={trans('action.close')}
            on:click={() => resetView()}
        >
            <VpCloseIcon class="size-xl" />
        </button>
    </div>
    <!-- CONTENT -->
    <div
        class="no-scrollbar flex flex-1 flex-col overflow-y-auto px-l desktop:px-3xl"
    >
        <div class="flex h-full w-full flex-col">
            <VerticalFiltersContent {handleSelectedFilter} />

            <div
                class="sticky bottom-0 left-0 flex w-full justify-between border-t border-solid border-border-quiet bg-white py-s"
            >
                <Button
                    size="small"
                    intent="secondary"
                    shape="rounded"
                    type="button"
                    on:click={() => handleResetSecondaryValues()}
                    startIcon={VpReturnIcon}
                    >{trans('search.filter.sidebar.clear')}</Button
                >

                <Button
                    size="small"
                    shape="rounded"
                    on:click={() => {
                        closeDrawer();
                    }}
                >
                    {#if $filtersContext.isSubmitting}
                        <VpRefreshIcon class="size-m animate-spin " />
                    {:else}
                        {trans('search.filter.sidebar.apply')}
                        {#if $filteredToursCount !== null}
                            ({$filteredToursCount}){/if}
                    {/if}
                </Button>
            </div>
        </div>
    </div>
</section>
